"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLACE_ROLES = void 0;
exports.PLACE_ROLES = {
    'Place user': 'Place user',
    'Place admin': 'Place admin'
};
